import {
    Button,
    Modal,
    Switch,
  } from "@mui/joy";
  import { BLACK, WHITE } from "../../../../../appConstants";
  import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
  } from "react";
  import CalenderIcon from "../../../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";
import DragAndDropIcon from "../../../../../svg/Ads_Dashboard_Developement2/Drag_and_Drop_Icon/elements.svg";
import toast from "react-hot-toast";
import MultiSelect from "../../../MultiSelect";
import DateRangeComponent from "../../../SummaryDateRangeComponent/DateRangeComponent 1";

  type ProductDetailsProps = {
    id: number;
    detail_name: string;
    backend_name: string;
    toggle: boolean;
    position: number;
  };
  type Matrice = {
    id: number;
    matrice_name: string;
    backend_matrice_name: string;
    toggle: boolean;
    position: number;
  };
  type RangeProps = {
    min_date: Date;
    max_date: Date;
  };
  type WeekProps = [number, number];
type FilterProps = {
  filter_type: string;
  period_type: string;
  month: number[];
  year: number[];
  week: WeekProps[];
  start_date: Date;
  end_date: Date;
};
type DateProps = {
  startDate: Date;
  endDate: Date;
};
type MonthProps = {
  id: string;
  label: string;
};
type YearProps = {
  id: string;
  label: string;
};
  type SummaryCustomExportModalProps = {
    setToggle: Dispatch<SetStateAction<boolean>>;
    ip_maxminRange: RangeProps;
    ip_filter: FilterProps;
    ip_years: YearProps[],
    ip_months: MonthProps[],
    ip_weeks: MonthProps[],
    ip_periodArr: string[],
    productDetailsData: ProductDetailsProps[];
    matricesData: Matrice[];
    exportfunc : (filter: FilterProps, productDetails: string[], matrices: string[]) => void;
    loading: boolean;
  };
  
  const SummaryCustomExportModal: React.FC<SummaryCustomExportModalProps> = ({
    setToggle,
    ip_maxminRange,
    ip_filter,
    ip_years,
    ip_months,
    ip_weeks,
    ip_periodArr,
    productDetailsData,
    matricesData,
    exportfunc,
    loading
  }) => {
    const [filter, setFilter] = useState<FilterProps>({} as FilterProps);    
    const [range, setRange] = useState<RangeProps>({} as RangeProps);
    const [initial_productDetails, setInitial_productDetails] = useState<ProductDetailsProps[]>([]);
    const [initial_matrices, setInitial_matrices] = useState<Matrice[]>([]);
    const [dateToggle, setDateToggle] = useState<boolean>(false);

  const [selectedYears, setSelectedYears] = useState<Set<string>>(new Set([]));

  const onYearChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedYears);

    if (e.target.checked) {
      if (id === "Select All") {
        ip_years.forEach((m) => set.add(m.id));
        setFilter((prev) => {
          return {
          ...prev,
          filter_type: "SEGMENT",
          year: ip_years
            .filter((m) => m?.id !== "Select All") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
          }
        });

      } else if (id !== "Select All") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          year: [...prev.year, Number(id)],
          filter_type: "SEGMENT",
        }));
        if (set.size === ip_years.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === ip_years.length) {
        set.clear();

        if(filter?.week?.length === 0 && filter?.month?.length === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "SEGMENT",
          }));
        }

      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);

        if(filter?.week?.length === 0 && filter?.month?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            year: [],
            filter_type: "TIMELINE",
          }));
        }
        else{
          setFilter((prev) => ({
            ...prev,
            year: prev.year.filter((yearId) => yearId !== Number(id)),
            filter_type: "SEGMENT",
          }));
        }

      }
    }
    setSelectedYears(set);
  };

  // ---- Months
  const [selectedMonths, setSelectedMonths] = useState<Set<string>>(
    new Set([])
  );

  const onMonthChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedMonths);
    if (e.target.checked) {
      if (id === "13") {
        ip_months.forEach((m) => set.add(m.id));
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: ip_months
            .filter((m) => m?.id !== "13") // Exclude items with id === '13'
            .map((m) => Number(m?.id)), // Convert remaining ids to numbers
        }));
      } else if (id !== "13") {
        set.add(id);
        setFilter((prev) => ({
          ...prev,
          filter_type: "SEGMENT",
          month: [...prev.month, Number(id)],
        }));
        if (set.size === ip_months.length - 1) {
          set.add("13");
        }
      }
    } else {
      if (id === "13" && set.size === ip_months.length) {
        set.clear();

        if(filter?.year?.length === 0 && filter?.week?.length === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: [],
          }));
        }

      } else if (id !== "13") {
        if (set.has("13")) {
          set.delete("13");
        }
        set.delete(id);

        if(filter?.year?.length === 0 && filter?.week?.length === 0 && set?.size === 0){
          setFilter((prev) => ({
            ...prev,
            month: [],
            filter_type: "TIMELINE",
          }));
        }
        else {
          setFilter((prev) => ({
            ...prev,
            filter_type: "SEGMENT",
            month: prev.month.filter((monthId) => monthId !== Number(id)),
          }));
        }

      }
    }
    setSelectedMonths(set);
  };

  const [selectedWeeks, setSelectedWeeks] = useState<Set<string>>(new Set([]));
  const [selweeks, setSelweeks] = useState<WeekProps[]>([]);

  const onWeekChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    let set = new Set(selectedWeeks);
    if (e.target.checked) {
      if (id === "6") {
        ip_weeks.forEach((m) => set.add(m?.id));
        setSelweeks(() => [
          [1, 7],
          [8, 14],
          [15, 21],
          [22, 28],
          [29, 31],
        ]);
      } else if (id !== "6") {
        set.add(id);
        if (set.size === ip_weeks.length - 1) {
          set.add("6");
        }
        if (id === "1") {
          setSelweeks((prev) => [...prev, [1, 7]]);
        } else if (id === "2") {
          setSelweeks((prev) => [...prev, [8, 14]]);
        } else if (id === "3") {
          setSelweeks((prev) => [...prev, [15, 21]]);
        } else if (id === "4") {
          setSelweeks((prev) => [...prev, [22, 28]]);
        } else if (id === "5") {
          setSelweeks((prev) => [...prev, [29, 31]]);
        }
      }
    } else {
      if (id === "6" && set.size === ip_weeks.length) {
        set.clear();
        setSelweeks([]);
      } else if (id !== "6") {
        if (set.has("6")) {
          set.delete("6");
        }
        if (set.has(id)) {
          set.delete(id);
          if (id === "1") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 1 && range[1] === 7))
            );
          } else if (id === "2") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 8 && range[1] === 14))
            );
          } else if (id === "3") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 15 && range[1] === 21))
            );
          } else if (id === "4") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 22 && range[1] === 28))
            );
          } else if (id === "5") {
            setSelweeks((prev) =>
              prev.filter((range) => !(range[0] === 29 && range[1] === 31))
            );
          }
        }
      }
    }
    let dummyset = [...set];
    dummyset = dummyset.filter((item) => item !== "6");
    const datesarr: WeekProps[] = [
      [1, 7],
      [8, 14],
      [15, 21],
      [22, 28],
      [29, 31],
    ];
    const weeksarr: WeekProps[] = dummyset.map((i) => datesarr[Number(i) - 1]);
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && weeksarr?.length === 0){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }
    else {
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeksarr,
      }));
    }
    setSelectedWeeks(set);
  };

  // OR Date
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let start, end;
    if (e.target.name === "startDate") {
      start = e.target.value;
      setStartDate(e.target.value);
    } else {
      end = e.target.value;
      setEndDate(e.target.value);
    }
    let weeklist: WeekProps[] = [];
    if (startDate && end) {
      weeklist = [[Number(startDate), Number(end)]];
    } else if (start && endDate) {
      weeklist = [[Number(start), Number(endDate)]];
    }
    // else if(startDate !== "" && end === "" || start === "" && endDate !== "" || startDate === "" && endDate === ""){
    //   weeklist = [];
    // }
    if(filter?.year?.length === 0 && filter?.month?.length === 0 && filter?.week?.length > 0 && filter?.filter_type === "SEGMENT"){
      setFilter((prev) => ({
        ...prev,
        filter_type: "TIMELINE",
        week: [],
      }));
    }

    if((startDate && end) || (start && endDate)){
      setFilter((prev) => ({
        ...prev,
        filter_type: "SEGMENT",
        week: weeklist,
      }));
    } 

  };

  const apply = (date: DateProps) => {
    setFilter((prev) => ({
      ...prev,
      filter_type: "TIMELINE",
      start_date: date?.startDate,
      end_date: date?.endDate,
    }));
  };

    // For Product Detail
    const ProductDetailSwitchChangeHandler = (detail_id: Number) => {
        const Exist = initial_productDetails.find(
        (d: ProductDetailsProps) => d?.id === detail_id
        )?.toggle;
        let newProductDetailsArr = [] as ProductDetailsProps[];
        if (Exist) {
            if (initial_productDetails.filter((item) => item.toggle).length === 1) {
                toast.error("Minimum 1 Product Detail to be present");
                return;
            } else if (initial_productDetails.filter((item) => item.toggle).length > 1) {
                newProductDetailsArr = initial_productDetails.map((d) =>
                    d.id === detail_id ? { ...d, toggle: false } : d
                );
            }
        } else {
            newProductDetailsArr = initial_productDetails.map((d) =>
                d.id === detail_id ? { ...d, toggle: true } : d
            );
        }
        setInitial_productDetails(newProductDetailsArr);
    };

    // For Metricess
    const MatriceSwitchChangeHandler = (matrice_id: Number) => {
        const Exist = initial_matrices.find(
            (d: Matrice) => d?.id === matrice_id
        )?.toggle;
        let newMatricesArr = [] as Matrice[];
        if (Exist) {
            if (initial_matrices.filter((item) => item.toggle).length === 1) {
                toast.error("Minimum 1 Matrice to be present");
                return;
            } else if (initial_matrices.filter((item) => item.toggle).length > 1) {
                newMatricesArr = initial_matrices.map((d) =>
                    d.id === matrice_id ? { ...d, toggle: false } : d
                );
            }
        } else {
            newMatricesArr = initial_matrices.map((d) =>
            d.id === matrice_id ? { ...d, toggle: true } : d
            );
        }
        setInitial_matrices(newMatricesArr);
        // updateColumns([], "METRICE", [], newMatricesArr, true);
    };

    // Drag & Drop Functionality
    // For Product Detail
    const [draggedProductDetail, setDraggedProductDetail] =
        useState<ProductDetailsProps | null>(null);

    const productDetailsDragStarthandle = (item: ProductDetailsProps) => {
        setDraggedProductDetail(item);
    };

    const productDetailsDragOverhandle = (
        event: React.DragEvent<HTMLDivElement>
    ) => {
        event.preventDefault();
    };

    const productDetailshandleDrop = (targetItem: ProductDetailsProps) => {
        if (!draggedProductDetail || draggedProductDetail.id === targetItem.id) return;
    
        const draggedIndex = initial_productDetails.findIndex(
        (item) => item?.id === draggedProductDetail.id
        );
        const targetIndex = initial_productDetails.findIndex(
        (item) => item?.id === targetItem.id
        );
    
        if (draggedIndex === -1 || targetIndex === -1) return;
    
        // Clone the array to avoid mutating state directly
        const updatedMatricesData = [...initial_productDetails];
    
        // Remove the dragged item
        const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
    
        // Insert it at the target index
        updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
    
        // Reassign position field based on new order
        const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
        ...item,
        position: index,
        }));
        setInitial_productDetails(reorderedMatricesData);
        
    };


    // For Metrice
    const [draggedMetrice, setDraggedMetrice] = useState<Matrice | null>(null);

    const metriceDragStarthandle = (item: Matrice) => {
        setDraggedMetrice(item);
    };

    const metriceDragOverhandle = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const metricehandleDrop = (targetItem: Matrice) => {
        if (!draggedMetrice || draggedMetrice.id === targetItem.id) return;
    
        const draggedIndex = initial_matrices.findIndex(
        (item) => item?.id === draggedMetrice.id
        );
        const targetIndex = initial_matrices.findIndex(
        (item) => item?.id === targetItem.id
        );
    
        if (draggedIndex === -1 || targetIndex === -1) return;
    
        // Clone the array to avoid mutating state directly
        const updatedMatricesData = [...initial_matrices];
    
        // Remove the dragged item
        const [draggedMatrice] = updatedMatricesData.splice(draggedIndex, 1);
    
        // Insert it at the target index
        updatedMatricesData.splice(targetIndex, 0, draggedMatrice);
    
        // Reassign position field based on new order
        const reorderedMatricesData = updatedMatricesData.map((item, index) => ({
        ...item,
        position: index,
        }));
        setInitial_matrices(reorderedMatricesData);
        // }
    };
    
    const exportHandler = () => {
        let selected_productdetails = initial_productDetails
        .filter((d) => d?.toggle === true)
        .map((item) => item?.backend_name);

        let selected_matrics = initial_matrices
            .filter((d) => d?.toggle === true)
            .map((item) => item?.backend_matrice_name);

        exportfunc(filter, selected_productdetails, selected_matrics);
    }
    useEffect(() => {
        setInitial_productDetails(productDetailsData);
        setInitial_matrices(matricesData);
        setFilter(ip_filter);
        setRange(ip_maxminRange);
    }, []);
  
    return (
      <Modal
        open={true}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        className="h-full"
      >
        <div className="relative">
          <div
            style={{
              width: 1200,
              height: 700,
              paddingLeft: 40,
              paddingRight: 40,
              paddingBottom: 40,
              paddingTop: 40,
              backgroundColor: `${WHITE.W_100}`,
            }}
            className="flex flex-col items-center justify-between rounded-[16px] gap-10"
          >
            <div className="h-[77px] flex justify-between items-start gap-1 w-full">
                <div className="flex flex-col w-[30%]">
                    <div
                        className="self-stretch"
                        style={{
                        color: `#1C1C1E`,
                        fontSize: 20,
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "26px",
                        }}
                    >
                        Select Export Preferences
                    </div>
                    <div
                        className="self-stetch"
                        style={{
                        color: `#97979A`,
                        fontSize: 14,
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "22px",
                        }}
                    >
                        Export the table or customise with specific Product Details, Metrics 
                    </div>
                </div>

                <div className="h-[77px] flex flex-col justify-between items-end">
                  <div
                    className="flex w-fit items-center justify-start gap-[10px] "
                  >
                    <div
                      className="flex px-[6px] py-[4px] items-center gap-2 rounded-[4px] h-[40px]"
                      style={{
                        border: "1px solid #EAEAED",
                      }}
                    >
                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_years}
                          selected={selectedYears}
                          onChange={onYearChange}
                          placeholder="Select Years"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                        />
                      </div>

                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_months}
                          selected={selectedMonths}
                          onChange={onMonthChange}
                          placeholder="Select Months"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                        />
                      </div>

                      <div className="flex flex-col items-start gap-2 self-stretch w-[124px] relative">
                        <MultiSelect
                          children={ip_weeks}
                          selected={selectedWeeks}
                          onChange={onWeekChange}
                          placeholder="Select Weeks"
                          containerstyle={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            // paddingTop: "8px",
                            // paddingBottom: "8px",
                            height: "28px",
                            borderRadius: 8,
                            border: `1px solid ${BLACK.B_5}`,
                          }}
                          fontstyle={{
                            fontSize: "10px",
                            lineHeight: "14px",
                            fontWeight: 400,
                            color: BLACK.B_40,
                          }}
                          checkboxcolor={"primary"}
                          dropdownheight={150}
                          disabled={startDate && endDate ? true : false}
                        />
                      </div>

                      <div className="flex flex-col items-center gap-[2px]">
                        <div
                          style={{
                            border: "1px solid #EAEAED",
                            height: "9px",
                            width: "0px",
                          }}
                        ></div>
                        <div
                          style={{
                            color: "var(--Text-Primary-Grey, #97979A)",
                            textAlign: "center",
                            fontFamily: "Inter",
                            fontSize: "8px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "10px", // 125%
                            letterSpacing: "1.6px",
                            textTransform: "uppercase",
                          }}
                        >
                          OR
                        </div>
                        <div
                          style={{
                            border: "1px solid #EAEAED",
                            height: "9px",
                            width: "0px",
                          }}
                        ></div>
                      </div>

                      <input
                        type="text"
                        placeholder="From"
                        name="startDate"
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          lineHeight: "14px",
                          color: "#97979A",
                          border: "1px solid #F2F2F5",
                          borderRadius: "4px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          width: "60px",
                          backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                        }}
                        value={startDate}
                        onChange={handleChange}
                        disabled={selweeks.length > 0 && true}
                      />
                      <input
                        type="text"
                        placeholder="Till"
                        name="endDate"
                        style={{
                          fontSize: "10px",
                          fontWeight: "400",
                          lineHeight: "14px",
                          color: "#97979A",
                          border: "1px solid #F2F2F5",
                          borderRadius: "4px",
                          paddingTop: "8px",
                          paddingBottom: "8px",
                          paddingLeft: "16px",
                          paddingRight: "16px",
                          width: "60px",
                          backgroundColor: selweeks.length > 0 ? "#F3F3F7" : "#FFF",
                        }}
                        value={endDate}
                        onChange={handleChange}
                        disabled={selweeks.length > 0 && true}
                      />
                    </div>

                    <div className="flex flex-col items-center gap-[2px]">
                      <div
                        style={{
                          border: "1px solid #EAEAED",
                          height: "10px",
                          width: "0px",
                        }}
                      ></div>
                      <div
                        style={{
                          color: "var(--Text-Primary-Grey, #97979A)",
                          textAlign: "center",
                          fontFamily: "Inter",
                          fontSize: "8px",
                          fontStyle: "normal",
                          fontWeight: 500,
                          lineHeight: "10px", // 125%
                          letterSpacing: "1.6px",
                          textTransform: "uppercase",
                        }}
                      >
                        OR
                      </div>
                      <div
                        style={{
                          border: "1px solid #EAEAED",
                          height: "10px",
                          width: "0px",
                        }}
                      ></div>
                    </div>

                    <div
                      className="flex items-center py-2 px-4 gap-2 rounded-[4px]"
                      style={{
                        border: "1px solid #EAEAED",
                        position: "relative",
                        backgroundColor:
                          filter?.year?.length !== 0 ||
                          filter?.month?.length !== 0 ||
                          filter?.week?.length !== 0
                            ? "#F3F3F7"
                            : "#FFF",
                        pointerEvents:
                          filter?.year?.length !== 0 ||
                          filter?.month?.length !== 0 ||
                          filter?.week?.length !== 0
                            ? "none"
                            : "auto",
                      }}
                    >
                      <div className="flex items-center gap-2">
                        <div
                          style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "10px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "14px",
                          }}
                        >
                          {`${String(filter?.start_date?.getDate()).padStart(
                            2,
                            "0"
                          )}/${String(filter?.start_date?.getMonth() + 1).padStart(
                            2,
                            "0"
                          )}/${filter?.start_date?.getFullYear()} - ${String(
                            filter?.end_date?.getDate()
                          ).padStart(2, "0")}/${String(
                            filter?.end_date?.getMonth() + 1
                          ).padStart(2, "0")}/${filter?.end_date?.getFullYear()} `}
                        </div>
                      </div>
                      <img
                        src={CalenderIcon}
                        alt="OverView Icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setDateToggle(true)}
                      />
                      {dateToggle && (
                        <div
                          className="absolute "
                          style={{ top: "37px", right: "0px", zIndex: 100 }}
                        >
                          <DateRangeComponent
                            range={{
                              startDate: filter?.start_date,
                              endDate: filter?.end_date,
                            }}
                            apply={apply}
                            minDate={range?.min_date}
                            maxDate={range?.max_date}
                            setDateToggle={setDateToggle}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div
                    className="flex h-[31px] items-center justify-end w-fit self-stretch"
                    style={{
                      borderBottom: "1px solid #EAEAED",
                      alignSelf: "flex-end"
                    }}
                  >
                    {ip_periodArr?.map((p) => (
                        <div
                          style={{
                            display: "flex",
                            padding: "0px 16px",
                            justifyContent: "center",
                            alignItems: "center",
                            alignSelf: "stretch",
                            cursor: "pointer",
                            borderBottom:
                              filter?.period_type === p
                                ? "1px solid #1565C0"
                                : "0px",
                          }}
                          key={p}
                          onClick={() => {
                            setFilter((prev) => ({
                              ...prev,
                              period_type: p,
                            }));
                          }}
                        >
                          <div
                            style={{
                              color:
                                filter?.period_type === p
                                  ? "#1565C0"
                                  : "var(--Text-Primary-Grey, #97979A)",
                              textAlign: "center",
                              fontFamily: "Inter",
                              fontSize: "12px",
                              fontStyle: "normal",
                              fontWeight: filter?.period_type === p ? 600 : 500,
                              lineHeight: "10px",
                              letterSpacing: "1.6px",
                              textTransform: "uppercase",
                            }}
                          >
                            {`${p} DATA`}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
            </div>

            <div className="w-full h-[423px] flex gap-10">
                <div
                className="flex flex-col items-start h-fit gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                  flex: 1,
                  maxHeight: '100%',
                  height: "fit-content"
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom: "1px solid #EAEAED"
                  }}
                //   onClick={() => {
                //     if (drawerSubOption === "PRODUCT_DETAILS") {
                //       setDrawerSubOption("");
                //     } else {
                //       setDrawerSubOption("PRODUCT_DETAILS");
                //     }
                //   }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Product Details
                    </div>
                    {/* {drawerSubOption === "PRODUCT_DETAILS" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.83366 11.6667C6.70866 11.6667 6.60796 11.625 6.53158 11.5417C6.45519 11.4583 6.41699 11.3611 6.41699 11.25C6.41699 11.2222 6.45866 11.125 6.54199 10.9583L9.56283 7.9375C9.63227 7.86806 9.70171 7.81944 9.77116 7.79167C9.8406 7.76389 9.91699 7.75 10.0003 7.75C10.0837 7.75 10.16 7.76389 10.2295 7.79167C10.2989 7.81944 10.3684 7.86806 10.4378 7.9375L13.4587 10.9583C13.5003 11 13.5316 11.0451 13.5524 11.0938C13.5732 11.1424 13.5837 11.1944 13.5837 11.25C13.5837 11.3611 13.5455 11.4583 13.4691 11.5417C13.3927 11.625 13.292 11.6667 13.167 11.6667H6.83366Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M9.56234 12.0625L6.5415 9.04167C6.49984 9 6.46859 8.95486 6.44775 8.90625C6.42692 8.85764 6.4165 8.80556 6.4165 8.75C6.4165 8.63889 6.4547 8.54167 6.53109 8.45834C6.60748 8.375 6.70817 8.33334 6.83317 8.33334H13.1665C13.2915 8.33334 13.3922 8.375 13.4686 8.45834C13.545 8.54167 13.5832 8.63889 13.5832 8.75C13.5832 8.77778 13.5415 8.875 13.4582 9.04167L10.4373 12.0625C10.3679 12.1319 10.2984 12.1806 10.229 12.2083C10.1596 12.2361 10.0832 12.25 9.99984 12.25C9.9165 12.25 9.84012 12.2361 9.77067 12.2083C9.70123 12.1806 9.63178 12.1319 9.56234 12.0625Z"
                          fill="#1C1C1E"
                        />
                      </svg>
                    )} */}
                  </div>
                </div>
                <div className="flex flex-col items-start self-stretch" style={{
                  overflowY: 'auto'
                }}>
                {initial_productDetails?.length > 0 &&
                    initial_productDetails?.map((p: ProductDetailsProps) => (
                    <div
                        className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                        key={p?.detail_name}
                        draggable
                        onDragStart={() => productDetailsDragStarthandle(p)}
                        onDragOver={productDetailsDragOverhandle}
                        onDrop={() => productDetailshandleDrop(p)}
                    >
                        <div className="flex items-center gap-1">
                        <img
                            src={DragAndDropIcon}
                            alt="Drag And Drop Icon"
                            style={{ cursor: "pointer" }}
                        />
                        <div
                            className=""
                            style={{
                            fontFamily: "Inter",
                            paddingLeft: "5px",
                            color: "#1C1C1E",
                            fontSize: "12px",
                            fontWeight: p?.toggle ? 600 : 400,
                            lineHeight: "18px",
                            }}
                        >
                            {p?.detail_name}
                        </div>
                        </div>
                        <Switch
                            checked={p?.toggle}
                            onChange={(event) => 
                            ProductDetailSwitchChangeHandler(p?.id)
                            }
                        />
                    </div>
                    ))}
                </div>
               </div>

                {/* Metrices */}
              <div
                className="flex flex-col items-start h-fit gap-4 self-stretch rounded-[4px]"
                style={{
                  border: "1px solid #EAEAED",
                  flex: 1,
                  maxHeight: '100%'
                }}
              >
                <div
                  className="flex items-start self-stretch rounded-[4px] cursor-pointer"
                  style={{
                    borderBottom: "1px solid #EAEAED"
                  }}
                //   onClick={() => {
                //     if (drawerSubOption === "METRICES") {
                //       setDrawerSubOption("");
                //     } else {
                //       setDrawerSubOption("METRICES");
                //     }
                //   }}
                >
                  <div className="flex h-[44px] w-full justify-between px-4 py-2 items-center gap-2 ">
                    <div
                      style={{
                        color: "var(--Text-Primary-Black, #1C1C1E)",
                        fontFamily: "Inter",
                        fontSize: "10px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "10px", // 100%
                        letterSpacing: "1.6px",
                        textTransform: "uppercase",
                      }}
                    >
                      Metrics
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-start self-stretch" style={{
                    overflowY: 'auto',
                }}>
                    {initial_matrices.length > 0 &&
                    initial_matrices?.map((m: Matrice) => (
                        <div
                            className="flex justify-between items-center h-[40px] p-4 gap-2 self-stretch"
                            key={m?.matrice_name}
                            draggable
                            onDragStart={() => metriceDragStarthandle(m)}
                            onDragOver={metriceDragOverhandle}
                            onDrop={() => metricehandleDrop(m)}
                        >
                            <div className="flex items-center gap-1">
                            <img
                                src={DragAndDropIcon}
                                alt="Drag And Drop Icon"
                                style={{ cursor: "pointer" }}
                            />
                            <div
                                className=""
                                style={{
                                fontFamily: "Inter",
                                paddingLeft: "5px",
                                color: "#1C1C1E",
                                fontSize: "12px",
                                fontWeight: m?.toggle ? 600 : 400,
                                lineHeight: "18px",
                                }}
                            >
                                {m?.matrice_name}
                            </div>
                            </div>
                            <Switch
                            checked={m?.toggle}
                            onChange={(event) =>
                              MatriceSwitchChangeHandler(m?.id)
                            }
                            />
                        </div>
                    ))}
                </div>
              </div>
            </div>

            <div className="flex items-start justify-center gap-10 self-stretch">
              <Button
                color="neutral"
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#FFF",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                  color: "#1C1C1E",
                  borderRadius: "8px",
                  border: "1px solid #F2F2F5",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                onClick={() => setToggle(false)}
              >
                Cancel
              </Button>
              <Button
                onClick={exportHandler}
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#1565C0",
                  color: "#FFF",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                loading={loading}
              >
                Export
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  
  export default SummaryCustomExportModal;
  